import { http as authHttp } from './http'

export const registerUser = data => authHttp.post('/user/register', data)

export const loginUser = data => authHttp.post('/user/login', data)

export const loginAdmin = data => authHttp.post('/admin/login', data)

export const getUserProfile = userId => authHttp.get('/user/profile', { params: { userId } })

export const updateUserProfile = data => authHttp.post('/user/profile/update', data)

export const changeUserPassword = data => authHttp.post('/user/profile/password', data)
